export default __webpack_public_path__ + "static/media/favelas-exclusive-license.c61bd92b.jpg";